/* Ever Desi Studio: makes customers choose a zodiac sign on tagged gift sets. */
(function () {
  if (window.__zodiacChoice) return;
  window.__zodiacChoice = true;

  var css =
    '.zc-page variant-selects .form__label{font-weight:700;font-size:1.6rem;color:#c40000}' +
    '.zc-unchosen .shopify-payment-button{display:none}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var ADD_TEXT = /add|cart|toevoeg|winkel|warenkorb|legen/i;

  /* ---------- Product cards (collection pages, related products, search) ---------- */
  function setupCards() {
    document.querySelectorAll('.card-wrapper .zodiac-choice-data').forEach(function (data) {
      var wrapper = data.closest('.card-wrapper');
      var item = data.closest('.grid__item') || wrapper;
      if (!item.hasAttribute('data-zc-url')) {
        item.setAttribute('data-zc-url', data.getAttribute('data-url'));
        item.classList.add('zc-card');
      }
      /* The add-to-cart app adds its controls after the page loads, so this re-runs. */
      item.querySelectorAll('button, input[type="submit"]').forEach(function (btn) {
        if (btn.closest('.card__inner') || btn.hasAttribute('data-zc-btn')) return;
        var text = btn.value || btn.textContent || '';
        if (!ADD_TEXT.test(text)) return;
        btn.setAttribute('data-zc-btn', '1');
        if (btn.tagName === 'INPUT') btn.value = data.getAttribute('data-label');
        else btn.textContent = data.getAttribute('data-label');
        var form = btn.closest('form');
        var scope = form || btn.parentElement;
        if (scope) {
          scope.querySelectorAll('input[type="number"], [class*="quantity"], [class*="qty"]').forEach(function (q) {
            if (!q.contains(btn)) q.style.display = 'none';
          });
        }
      });
    });
  }

  function isCardBuyAction(target) {
    var item = target.closest && target.closest('[data-zc-url]');
    if (!item) return null;
    var btn = target.closest('button, input[type="submit"]');
    if (!btn || btn.closest('.card__inner')) return null;
    return btn.hasAttribute('data-zc-btn') || ADD_TEXT.test(btn.value || btn.textContent || '') ? item : null;
  }

  document.addEventListener(
    'click',
    function (e) {
      var item = isCardBuyAction(e.target);
      if (!item) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = item.getAttribute('data-zc-url');
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var item = e.target.closest && e.target.closest('[data-zc-url]');
      if (item) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = item.getAttribute('data-zc-url');
        return;
      }
      if (document.documentElement.classList.contains('zc-unchosen') && e.target.closest('.product__info-wrapper')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  /* ---------- Product page ---------- */
  function pageData() {
    return document.querySelector('.product__info-wrapper .zodiac-choice-data');
  }

  function lockProduct(label) {
    document.documentElement.classList.add('zc-unchosen');
    document.querySelectorAll('.product__info-wrapper variant-selects input[type="radio"]').forEach(function (r) {
      r.checked = false;
    });
    var btn = document.querySelector('.product__info-wrapper .product-form__submit');
    if (btn) {
      btn.disabled = true;
      var span = btn.querySelector('span');
      if (span) span.textContent = label;
    }
  }

  function setupProduct() {
    var data = pageData();
    if (!data) return;
    var label = data.getAttribute('data-label');
    document.documentElement.classList.add('zc-page');
    if (!data.getAttribute('data-selected') && !window.__zodiacChosen) lockProduct(label);
  }

  document.addEventListener(
    'change',
    function (e) {
      if (!e.target.closest || !e.target.closest('.product__info-wrapper variant-selects')) return;
      window.__zodiacChosen = true;
      document.documentElement.classList.remove('zc-unchosen');
      var btn = document.querySelector('.product__info-wrapper .product-form__submit');
      var span = btn && btn.querySelector('span');
      if (span && window.variantStrings) span.textContent = window.variantStrings.addToCart;
      /* The theme then updates the button again if the chosen sign is sold out. */
      if (btn && !e.target.classList.contains('disabled')) btn.disabled = false;
    },
    true
  );

  function init() {
    setupProduct();
    setupCards();
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(setupCards, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Browsers can restore the old selection when going back to a page. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted || (performance.getEntriesByType('navigation')[0] || {}).type === 'back_forward') {
      window.__zodiacChosen = false;
      setupProduct();
    }
  });
})();
